import React from 'react';
import { Switch } from '@headlessui/react';
function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}
export default function ToggleSwitch({ enabled, onChange }) {
    return (React.createElement(Switch, { checked: enabled, onChange: onChange, className: classNames(enabled ? 'bg-green-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2') },
        React.createElement("span", { className: "sr-only" }, "Use setting"),
        React.createElement("span", { "aria-hidden": "true", className: classNames(enabled ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out') })));
}
